@if (!isFullSize) {
	<div class="list-item filter no-hover">
		<div class="label">
			<h5 translate="filter.show"></h5>
			<div class="switch-filter">
				<input id="search.filter" type="checkbox" hidden="hidden" [(ngModel)]="showFilter" />
				<label for="search.filter" class="switch"></label>
			</div>
		</div>
	</div>
	@if (showFilter) {
		<stages-process-interfaces-filter
			[standaloneStyle]="false"
			[dropdownContent]="(dropdownContent$ | async)!"
			[showSearch]="true"
		/>
	}
}

@if (dataSource) {
	<stages-responsive-data-view
		#dataView
		[dataSource]="dataSource"
		[listItemTemplate]="listItemTemplate"
		[tableItemTemplate]="tableItemTemplate"
		[headerTemplate]="tableHeaderTemplate"
		[informationTemplate]="informationTemplate"
		[idFn]="ProcessInterfacesInterfacesSelection.getId"
		[idFnNew]="ProcessInterfacesInterfacesSelection.getIdNew"
		[disabledFn]="ProcessInterfacesInterfacesSelection.isDisabled"
		[disabledFnNew]="ProcessInterfacesInterfacesSelection.isDisabled"
		[isPreselectedFn]="ProcessInterfacesInterfacesSelection.isPreselected"
		[mode]="mode"
		[parentIdentifier]="ProcessInterfacesInterfacesSelection.getParentIdentifier"
		[storeIdentifier]="storeIdentifier"
		[showSelectAllSwitch]="false"
		[explicitParentMode]="false"
		translateNone="none"
	/>
}

<ng-template #listItemTemplate let-item>
	<li class="list-item no-padding">
		<div class="label">
			<div class="text">
				<h4>
					@if (item.actions.OpenSourceElement) {
						<a
							[ngClass]="{ clickable: clickable(), tailored: item.sourceElementTailored }"
							[routerLink]="getSourceElementLink(item)"
							>{{ item.sourceElementName }}
							@if (item.dependentSourceElement) {
								<span> ({{ item.dependentSourceElementLabel }})</span>
							}
						</a>
					}
					@if (!item.actions.OpenSourceElement) {
						<span [ngClass]="{ clickable: clickable(), tailored: item.sourceElementTailored }"
							>{{ item.sourceElementName }}
							@if (item.dependentSourceElement) {
								<span> ({{ item.dependentSourceElementLabel }})</span>
							}
						</span>
					}
					<span>&nbsp;<span translate="management.process.interfaces.page.interfaces.to"></span>&nbsp;</span>
					@if (item.actions.OpenTargetElement) {
						<a
							[ngClass]="{ clickable: clickable(), tailored: item.targetElementTailored }"
							[routerLink]="getTargetElementLink(item)"
							>{{ item.targetElementName }}
							@if (item.dependentTargetElement) {
								<span> ({{ item.dependentTargetElementLabel }})</span>
							}
						</a>
					}
					@if (!item.actions.OpenTargetElement) {
						<span [ngClass]="{ clickable: clickable(), tailored: item.targetElementTailored }"
							>{{ item.targetElementName }}
							@if (item.dependentTargetElement) {
								({{ item.dependentTargetElementLabel }})
							}
						</span>
					}
				</h4>
				<p>
					<span
						>{{ item.sourceElementType.name }}
						<span translate="management.process.interfaces.page.interfaces.to"></span>
						{{ item.targetElementType.name }}
					</span>
				</p>
				<p class="subheadline">
					<span class="badge" [ngClass]="'info-badge '">{{ item.associationTypeLabel }}</span>
					@if (showOnlyChanges && getAssociationChangeType(item) !== "no_change") {
						<span
							class="badge"
							[ngClass]="getAssociationChangeType(item)"
							[translate]="'management.process.interfaces.changetype.' + getAssociationChangeType(item)"
						></span>
					}
				</p>
			</div>
		</div>
	</li>
	<li class="separator"></li>
</ng-template>
<ng-template #tableHeaderTemplate>
	<th translate="management.process.interfaces.page.interfaces.th1"></th>
	<th translate="management.process.interfaces.page.interfaces.th2"></th>
	<th translate="management.process.interfaces.page.interfaces.th3"></th>
	@if (showOnlyChanges) {
		<th translate="management.process.interfaces.page.interfaces.th4"></th>
	}
</ng-template>
<ng-template #tableItemTemplate let-item>
	<td>
		<div class="list-item no-padding">
			@if (item.actions.OpenSourceElement) {
				<a class="label" [routerLink]="getSourceElementLink(item)">
					<ng-container *ngTemplateOutlet="sourceElementTemplate; context: { item: item }"></ng-container>
				</a>
			}
			@if (!item.actions.OpenSourceElement) {
				<span class="label">
					<ng-container *ngTemplateOutlet="sourceElementTemplate; context: { item: item }"></ng-container>
				</span>
			}
		</div>
	</td>
	<td>
		<div class="list-item no-padding">
			@if (item.actions.OpenTargetElement) {
				<a class="label" [routerLink]="getTargetElementLink(item)">
					<ng-container *ngTemplateOutlet="targetElementTemplate; context: { item: item }"></ng-container>
				</a>
			}
			@if (!item.actions.OpenTargetElement) {
				<span class="label">
					<ng-container *ngTemplateOutlet="targetElementTemplate; context: { item: item }"></ng-container>
				</span>
			}
		</div>
	</td>
	<td>{{ item.associationTypeLabel }}</td>
	@if (showOnlyChanges) {
		<td>
			@if (getAssociationChangeType(item) !== "no_change") {
				<span
					class="badge"
					[ngClass]="getAssociationChangeType(item)"
					[translate]="'management.process.interfaces.changetype.' + getAssociationChangeType(item)"
				></span>
			}
		</td>
	}
</ng-template>

<ng-template #sourceElementTemplate let-item="item">
	<i class="ico avatar-cell-48" [ngClass]="getIconClasses(item.sourceElementType, false)"></i>
	<div class="text">
		<h4 [ngClass]="{ tailored: item.sourceElementTailored }">
			<span>{{ item.sourceElementName }}</span>
		</h4>
		@if (item.dependentSourceElement) {
			<p>
				{{ item.dependentSourceElementLabel }}
				<i class="ico" [ngClass]="getIconClasses(item.sourceElementType, true)"></i>
			</p>
		}
		<p>{{ item.sourceElementType.name }}</p>
	</div>
</ng-template>

<ng-template #targetElementTemplate let-item="item">
	<i class="ico avatar-cell-48" [ngClass]="getIconClasses(item.targetElementType, false)"></i>
	<div class="text">
		<h4 [ngClass]="{ tailored: item.targetElementTailored }">
			<span>{{ item.targetElementName }}</span>
		</h4>
		@if (item.dependentTargetElement) {
			<p>
				{{ item.dependentTargetElementLabel }}
				<i class="ico" [ngClass]="getIconClasses(item.targetElementType, true)"></i>
			</p>
		}
		<p>{{ item.targetElementType.name }}</p>
	</div>
</ng-template>

<ng-template #informationTemplate>
	<div class="text">
		<p
			[translate]="'management.process.interfaces.page.interfaces.connectFromTo'"
			[translateParams]="{ workspaceFrom: workspaceNameFrom, workspaceTo: workspaceNameTo }"
		></p>
	</div>
</ng-template>
